export const galleryImages = [
  {
    title: 'Afro-Luxe Living Room',
    category: 'Nigerian Contemporary',
    url: 'https://public.readdy.ai/ai/img_res/11cdded5a59a4113b6858271f256bc73.jpg'
  },
  {
    title: 'Modern Nigerian Kitchen',
    category: 'Residential',
    url: 'https://readdy.ai/api/search-image?query=modern%20Nigerian%20kitchen%20interior%20design%20warm%20wood%20cabinets%20marble%20countertops%20contemporary%20style%20clean%20lines%20African%20wood%20accents%20tropical%20greenery%20natural%20lighting%20warm%20tones&width=600&height=600&seq=gallery-2&orientation=squarish'
  },
  {
    title: 'Luxury Nigerian Bedroom',
    category: 'Afro-Luxe',
    url: 'https://readdy.ai/api/search-image?query=luxury%20Nigerian%20master%20bedroom%20interior%20design%20elegant%20bedding%20with%20Ankara-inspired%20patterns%20sophisticated%20warm%20color%20palette%20African%20wood%20furniture%20beautiful%20lighting%20high-end%20residential%20tropical%20plants%20rich%20textiles&width=600&height=600&seq=gallery-3&orientation=squarish'
  },
  {
    title: 'Spa Bathroom with Local Stone',
    category: 'Residential',
    url: 'https://readdy.ai/api/search-image?query=spa%20bathroom%20interior%20design%20Nigerian%20style%20natural%20stone%20tiles%20luxury%20fixtures%20modern%20elegant%20relaxing%20atmosphere%20African%20natural%20materials%20warm%20tones%20tropical%20plants%20terracotta%20accents&width=600&height=600&seq=gallery-4&orientation=squarish'
  },
  {
    title: 'Nigerian Home Office',
    category: 'Residential',
    url: 'https://readdy.ai/api/search-image?query=home%20office%20interior%20design%20Nigerian%20style%20modern%20workspace%20built-in%20African%20wood%20shelving%20natural%20light%20productive%20environment%20contemporary%20furniture%20with%20local%20craftsmanship%20warm%20tones%20tropical%20plants&width=600&height=600&seq=gallery-5&orientation=squarish'
  },
  {
    title: 'Elegant Dining Room',
    category: 'Nigerian Contemporary',
    url: 'https://readdy.ai/api/search-image?query=elegant%20Nigerian%20dining%20room%20interior%20design%20beautiful%20table%20setting%20with%20African-inspired%20centerpiece%20designer%20chandelier%20sophisticated%20warm%20atmosphere%20entertaining%20space%20rich%20wood%20furniture%20Afrocentric%20decor&width=600&height=600&seq=gallery-6&orientation=squarish'
  },
  {
    title: 'Tropical Outdoor Patio',
    category: 'Outdoor',
    url: 'https://readdy.ai/api/search-image?query=outdoor%20patio%20interior%20design%20Nigerian%20tropical%20style%20comfortable%20seating%20beautiful%20tropical%20landscaping%20elegant%20outdoor%20furniture%20with%20African%20patterns%20relaxing%20atmosphere%20lush%20greenery%20warm%20climate%20design&width=600&height=600&seq=gallery-7&orientation=squarish'
  },
  {
    title: 'Cozy Reading Nook',
    category: 'Afro-Luxe',
    url: 'https://readdy.ai/api/search-image?query=cozy%20reading%20nook%20interior%20design%20Nigerian%20style%20comfortable%20chair%20with%20Ankara%20cushions%20built-in%20African%20wood%20bookshelves%20natural%20light%20peaceful%20atmosphere%20warm%20tones%20tropical%20plants&width=800&height=800&seq=gallery-8&orientation=squarish'
  },
  {
    title: 'Nigerian Entryway',
    category: 'Residential',
    url: 'https://readdy.ai/api/search-image?query=elegant%20Nigerian%20entryway%20interior%20design%20welcoming%20atmosphere%20beautiful%20lighting%20designer%20furniture%20with%20African%20art%20pieces%20first%20impression%20warm%20tones%20local%20craftsmanship%20terracotta%20elements&width=600&height=600&seq=gallery-9&orientation=squarish'
  },
  {
    title: 'Luxury Walk-in Closet',
    category: 'Afro-Luxe',
    url: 'https://readdy.ai/api/search-image?query=luxury%20walk-in%20closet%20interior%20design%20Nigerian%20style%20organized%20storage%20beautiful%20lighting%20elegant%20design%20custom%20African%20wood%20cabinetry%20warm%20tones%20sophisticated%20space&width=600&height=600&seq=gallery-10&orientation=squarish'
  },
  {
    title: 'Vibrant Kids Room',
    category: 'Residential',
    url: 'https://readdy.ai/api/search-image?query=modern%20Nigerian%20kids%20bedroom%20interior%20design%20playful%20warm%20colors%20functional%20storage%20creative%20design%20with%20African-inspired%20patterns%20child-friendly%20space%20tropical%20theme%20local%20craftsmanship&width=600&height=600&seq=gallery-11&orientation=squarish'
  },
  {
    title: 'Wine Cellar with Local Wood',
    category: 'Nigerian Contemporary',
    url: 'https://readdy.ai/api/search-image?query=luxury%20wine%20cellar%20interior%20design%20Nigerian%20style%20elegant%20storage%20with%20African%20wood%20beautiful%20lighting%20sophisticated%20atmosphere%20premium%20design%20warm%20tones%20local%20craftsmanship&width=600&height=600&seq=gallery-12&orientation=squarish'
  }
];